import React from 'react'
import { useNavigate, useLocation } from '@/lib/router-dom';
import classNames from 'classnames';

export const NavigationLink = ({to, icon, text, disabled, hidden, onClick: onClickProp}) => {
	const { goTo } = useNavigate();
	const { currentPath } = useLocation();

	const onClick = (e) => {
		e.preventDefault();
		if (!disabled) {
			onClickProp?.();
			goTo(to);
		}
	}

	const isActive = currentPath.startsWith(to);

	const navigationClass = classNames({
		'navigation-item': true,
		'navigation-item--active': isActive,
		'navigation-item--disabled': disabled
	})

	if (hidden) return null;

	return (
		<a href={to} onClick={onClick} className={navigationClass} id="navigation-dashboard-tab">
			<div className="navigation-item__side__rectangle"></div>
			<div className="navigation-item__icon">{icon}</div>
			<div className="navigation-item__label">{text}</div>
		</a>
	)
}
